import styled from 'styled-components';

export const Input = styled.input`
  display: flex;
  width: 100%;
  min-height: 3rem;
  padding: 0 1rem;
  border-radius: 0;
  border: 1px solid ${({ theme }) => theme.colors.border};
  background: ${({ theme }) => theme.colors.background};
  color: ${({ theme }) => theme.colors.foreground};
  font-size: 0.875rem;
  outline: none;

  &::placeholder {
    color: ${({ theme }) => theme.colors.mutedForeground};
    opacity: 0.85;
  }

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 2px ${({ theme }) => theme.colors.ring};
    border-color: ${({ theme }) => theme.colors.champagne};
  }
`;
